import { RequestService } from '../../../../../common/services/RequestService';
import { API_TARIFF_FEE_PERIODS } from '../../constants';

export const getTariffFeePeriodsRequest = payload => {
  return RequestService.get(API_TARIFF_FEE_PERIODS).then(response => response);
};
